import type { RouteRecordRaw, Router } from 'vue-router'

const CybercrimeRoutes: RouteRecordRaw = {
  path: '/claim/cybercrime',
  name: 'CybercrimeModulePages',
  redirect: { name: '' },
  children: [
    {
      path: '',
      name: 'CybercrimeMainRoute',
      component: () => import('./views/CybercrimeView.vue'),
      meta: {
        title: 'cybercrime.cybercrimeClaims',
      },
    },
    {
      path: 'create',
      name: 'CybercrimeCreateRoute',
      component: () => import('./views/CybercrimeUpsertView.vue'),
      meta: {
        title: 'cybercrime.createCybercrime',
        pageHasBack: true,
      },
    },
    {
      path: 'edit/:cybercrimeId',
      name: 'CybercrimeEditRoute',
      component: () => import('./views/CybercrimeUpsertView.vue'),
      meta: {
        title: 'cybercrime.editCybercrime',
        pageHasBack: true,
      },
    },
    {
      path: 'view/:cybercrimeId',
      name: 'ViewCybercrimeRoute',
      component: () => import('./views/SingleCybercrimeView.vue'),
      meta: {
        title: 'cybercrime.ViewCybercrime',
        pageHasBack: true,
      },
    },
  ],
  meta: {
    layout: 'Default',
  },
}

export default (router: Router) => {
  router.addRoute(CybercrimeRoutes)
}
